
import React from 'react';
import { cn } from '@/lib/utils';

interface PriorityBadgeProps {
  quadrant: string;
  className?: string;
}

const quadrantConfig = {
  'do-first': {
    label: 'Do First',
    color: 'bg-red-500 text-white',
    icon: '🔥'
  },
  'schedule': {
    label: 'Schedule',
    color: 'bg-blue-500 text-white',
    icon: '📅'
  },
  'delegate': {
    label: 'Delegate',
    color: 'bg-yellow-600 text-white', // Darker yellow for better contrast
    icon: '🤝'
  },
  'eliminate': {
    label: 'Eliminate',
    color: 'bg-gray-600 text-white', // Darker gray for better contrast
    icon: '🗑️'
  }
};

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ quadrant, className }) => {
  const config = quadrantConfig[quadrant as keyof typeof quadrantConfig];
  
  if (!config) return null;

  return (
    <div className={cn(
      "inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full font-medium shadow-sm",
      config.color,
      className
    )}>
      <span className="text-xs">{config.icon}</span>
      <span>{config.label}</span>
    </div>
  );
};
